import { memo } from "react";
import { Card, CardContent, CardHeader } from "@/components/ui/card";
import { Order } from "@/hooks/useOrders";
import { NotificationSettings } from "@/hooks/useNotificationSettings";
import { OrderActions } from "@/components/OrderActions";
import { OrderIdentity } from "@/components/OrderIdentity";
import type { OrderActionKey } from "@/utils/orderActions";

interface OrderCardProps {
  order: Order;
  onSendConfirmation: (order: Order) => void | Promise<void>;
  onSendReadyNotification: (order: Order) => void | Promise<void>;
  onViewOffer: (order: Order) => void;
  onSendReviewRequest: (order: Order) => void | Promise<void>;
  notificationSettings?: NotificationSettings | null;
  /** Scoped to this order by the owner of the send guard; see useSendGuard. */
  isSending: (action: OrderActionKey) => boolean;
}

const OrderCard = ({
  order,
  onSendConfirmation,
  onSendReadyNotification,
  onViewOffer,
  onSendReviewRequest,
  notificationSettings,
  isSending,
}: OrderCardProps) => {
  const claimed = !!order.offer_claimed;

  return (
    <Card
      className={`bg-card shadow-sm transition-shadow duration-200 hover:shadow-md rounded-radius-card ${
        claimed ? "border-status-success/40 bg-status-success/[0.06]" : ""
      }`}
    >
      <CardHeader className="pb-3">
        <OrderIdentity order={order} />
      </CardHeader>

      <CardContent className="pt-0">
        <OrderActions
          order={order}
          onSendConfirmation={onSendConfirmation}
          onSendReadyNotification={onSendReadyNotification}
          onViewOffer={onViewOffer}
          onSendReviewRequest={onSendReviewRequest}
          notificationSettings={notificationSettings}
          isSending={isSending}
        />
      </CardContent>
    </Card>
  );
};

export default memo(OrderCard);
